// How admin → Textos groups and names the editable blocks (keys come from worker/src/content.ts).
// single: one value for both languages (links, emails, images). multiline: long text with format.
// Keys not listed here still show up under "Otros".
export const CONTENT_SECTIONS = [
  {
    title: "Marca y redes",
    keys: {
      "brand.name": { label: "Nombre de la tienda", help: "Sale en la cabecera y en el pie.", single: true },
      "image.logo.url": { label: "Logo", help: "Imagen cuadrada pequeña junto al nombre, arriba a la izquierda." },
      "social.instagram": { label: "Enlace de Instagram", help: "Vacío = se oculta el icono.", single: true },
      "social.discogs": { label: "Enlace de Discogs", help: "Vacío = se oculta el enlace.", single: true },
      "footer.tagline": { label: "Frase del pie de página", help: "Opcional. Sale bajo el nombre, abajo del todo." },
    },
  },
  {
    title: "Portada",
    keys: {
      "home.intro": { label: "Texto grande de la portada", help: "Sobre la foto principal.", multiline: true },
      "image.hero.url": { label: "Foto principal de la portada" },
      "home.latest.title": { label: "Título de «Novedades»" },
      "home.articles.title": { label: "Título de la sección de artículos" },
      "home.newsletter.title": { label: "Título del bloque de newsletter" },
      "home.newsletter.copy": { label: "Texto del bloque de newsletter", multiline: true },
    },
  },
  {
    title: "Disco de la semana",
    keys: {
      "featured.listing_id": { label: "Número del anuncio de Discogs", help: "El número que sale al final de la URL del anuncio. Vacío = no se muestra.", single: true },
      "featured.title": { label: "Título" },
      "featured.note": { label: "Comentario", multiline: true },
    },
  },
  {
    title: "Sobre",
    keys: {
      "about.title": { label: "Título" },
      "about.body": { label: "Texto", multiline: true },
      "image.about.url": { label: "Foto principal", help: "Sale a la derecha del texto. Vacío = sin foto." },
      "gallery.about": { label: "Galería de fotos", help: "Fotos de la tienda que salen debajo del texto." },
    },
  },
  {
    title: "Contacto",
    keys: {
      "contact.title": { label: "Título" },
      "contact.lead": { label: "Texto", multiline: true },
      "contact.email": { label: "Email de contacto", help: "Se muestra en la página de Contacto.", single: true },
      "contact.whatsapp": { label: "WhatsApp", help: "Con prefijo, ej. +34 600 000 000. Vacío = no se muestra.", single: true },
      "contact.address": { label: "Dirección / horario", help: "Opcional. Puedes usar varias líneas.", single: true, multiline: true },
    },
  },
  {
    title: "Compramos tus discos",
    keys: {
      "sell.title": { label: "Título" },
      "sell.lead": { label: "Texto", multiline: true },
    },
  },
  {
    title: "Envíos",
    keys: {
      "shipping.title": { label: "Título" },
      "shipping.body": { label: "Texto de la política de envíos", multiline: true },
    },
  },
  {
    title: "Pedidos (uso interno)",
    keys: {
      "order.payment": { label: "Instrucciones de pago", help: "No sale en la web: se añade al mensaje con el total que mandas al cliente.", multiline: true },
    },
  },
];

const ALL = Object.assign({}, ...CONTENT_SECTIONS.map((s) => s.keys));

/** Sections with the keys the server knows, plus "Otros" for anything new. Hidden: unused legacy keys. */
export function groupKeys(keys) {
  const hidden = new Set(["home.tiers.title", "home.tiers.lead"]);
  const known = new Set(Object.keys(ALL));
  const sections = CONTENT_SECTIONS.map((s) => ({
    title: s.title,
    items: Object.entries(s.keys).filter(([k]) => keys.includes(k)).map(([key, meta]) => ({ key, meta })),
  })).filter((s) => s.items.length);
  const others = keys.filter((k) => !known.has(k) && !hidden.has(k)).map((key) => ({ key, meta: { label: key } }));
  if (others.length) sections.push({ title: "Otros", items: others });
  return sections;
}
